import { Moment } from 'moment';

declare global {
  export const __DEV__: boolean;
  export const __BUILD__: string;
  export const __API_URL__: string;
  export const __API_KEY__: string;
  export const __TEST__: boolean;
  export const __URL_PROCESS_PAYMENT__: string;
  export const __URL_PAYMENT_FORM_ACTION__: string;
}

declare module 'loglevel' {
  export interface Logger {
    group(value: string): void;
    groupEnd(): void;
  }
}

// interface JQuery {
//   modal: (value: string) => any;
//   fullCalendar: (...args: any[]) => any;
// }

export interface ProductSearch {
  branchId: number;
  promoCode: string;
  paxs: Pax[];
}

export interface FullCalendarEvent {
  id: string;
  allDay: boolean;
  className: string[];
  custom: object | undefined;
  end: string | undefined;
  source: object;
  start: Moment;
  title: string;
  itemid?: string;
}

export interface FullCalendarView {
  name: string;
  type: string;
  start: Moment;
  end: Moment;
}

export type HeroEventType = 'Normal' | 'CheckIn' | 'CheckOut' | 'DepartureOnly';

export interface HeroEvent {
  id?: number;
  productId?: number;
  rateCode?: string;
  className: string;
  defaultTitle: string;
  title: string;
  start: Moment;
  end?: Moment;
  allDay: boolean;
  eventType: HeroEventType;
  availability?: number;
  itemId?: number;
  rrp: number;
}

export interface Pax {
  age: number;
  room: number;
  accessible: boolean;
}

export interface PersonBooking {
  title: string;
  firstName: string;
  lastName: string;
  emailAddress: string;
  phoneNumber: string;
  streetAddress: string;
  suburb: string;
  state: string;
  country: string;
  postcode: string;
  specialRequests: string;
  disabilityRequirements: string;
  terms: boolean;
  newsletter: boolean;
  giftFirstName: string;
  giftLastName: string;
  giftEmailAddress: string;
  giftMessage: string;
  giftValue: number;
  customValue: number;
}

export interface SelectedRoom {
  room: number | false;
  productId: string;
  productName: string;
  rateCode?: string;
  productRateCode?: string;
  rateName?: string;
  price: number;
  priceBeforeDiscount: number;
  checkIn: string | false;
  checkOut: string | false;
  questions: string[];
}

export interface ProductPriceList {
  price: number;
  html: string;
}

export interface DatePricing {
  // id: string;
  productId: number;
  // itemId: string;
  rateCode: string;
  advertisedPrice: number;
  levy: number;
  commission: number;
  currencyIso: string;
  totalAdvertisedPrice: number;
  totalLevy: number;
  variablePrice: boolean;
  saleFare: boolean;
  validFrom: unknown;
  validTo: unknown;
  perXPax: unknown;
  canSellSetDate: boolean;
  canSellOpenDated: boolean;
  fareTypes: unknown;
  fareTypeGroups: unknown;
  forcePickupLocationSelection: boolean;
  pickupLocations: unknown;
  productRateCode: string;
  rateName: string;
  availability: number;
  dateCheckIn: string;
  dateCheckOut: string;
  rrp: number;
  totalRrp: number;
  totalRrpBeforeDiscount: number;
  /**
   *  Cannot take arrival
   */
  cta: boolean;
  /**
   *  Cannot take depature
   */
  ctd: boolean;
  stopSell: boolean;
  maxNights: number;
  minNights: number;
}

export interface ProductPricingMulti {
  datePricing: DatePricing[];
}

export interface CustomEventCollectionItem {
  Zoo: string;
  name: string;
  Day: string;
  DayEnd: string;
  Colour: string;
  Icon: string;
  itemId: string;
}

export interface CustomEventCollection {
  items: CustomEventCollectionItem[];
}

export interface CustomEventResult {
  COLLECTION: CustomEventCollection;
}

export interface AjaxScheduleResult {
  datePricing: DatePricing[] | undefined;
}

export interface PriceDisplay {
  price: number;
}

export interface DatesDisplay {
  dates: string[];
}

type PaymentStateType = 'processing' | 'failed' | 'success' | 'complete';

export interface PaymentState {
  id: string;
  state: PaymentStateType;
}

export interface Dates {
  checkIn: string;
  checkOut: string;
}

export interface Promo {
  code: string;
}

export interface DiscountDate{
  date: string;
  timezone: string;
  timezone_type: number;
}
// export interface DiscountDateRange {
//   validFrom: DiscountDate;
//   validTo: DiscountDate;
// }
export interface Discount {
  code: string;
  per: number;
  siteId: number;
  callOutText: string;
  dates: string;
}

export interface GiftVoucher {
  code: string;
  value: number;
}

export interface BookingDetails {
  id: string;
  amount: number;
}

export interface stayVoucher {
  voucherCodes: string;
  value: number;
}

export interface FingerPrint {
  Timestamp: any;
  Fingerprint: any;
  MerchantId: any;
  ClientId: string;
}

export interface HeroApiBookingProductPax {
  room: number;
  paxId: string;
}

export interface HeroAjaxCreatePaxRequest {
  title: string;
  first: string;
  last: string;
  email: string;
  mobile: string;
  age: number;
  country: string;
  postcode: string;
}

export interface HeroApiCreatePaxResult {
  id: string;
  title: string;
  first: string;
  last: string;
  email: string;
  phone?: string;
  mobile?: string;
  age: number;
  country: string;
  postcode: string;
}

export interface HeroApiCreateBookingRequest {
  voucherCode: string;
  stayVouchers: string;
  discountPercentage: number;
  discountCode: string;
  siteId: number;
  bookingProducts: HeroApiBookingProduct[];
}

export interface HeroApiBooking {
  payable: number;
  id: string;
}

export interface HeroApiBookingProduct {
  productId: string;
  rateCode: string;
  productRateCode: string;
  paxRoomId: HeroApiBookingProductPax[];
  paxId: string[];
  agentReference?: string;
  voucherNotes?: string;
  rrp?: number;
}

export interface HeroApiBookingProductRoom extends HeroApiBookingProduct {
  dateCheckIn?: string;
  nights?: number;
  paxRoomId: HeroApiBookingProductPax[];
  // voucherNotes?: string;
}


export interface HeroApiBookingProductAddon extends HeroApiBookingProduct {
  addonName: string;
  price: number;
  room: number;
  quantity: number;
  questions: string[];
  dateCheckIn?: string;
}

export interface HeroApiBookingValidateResult {
  IsValid: boolean;
}

export class HeroApiWindcaveSessionRequest {
  bookingId: string;
  amount: string;
  origin: string;
  captchaToken: string;

  constructor(bookingId: string, amount: string, origin: string, captchaToken: string) {
    this.bookingId = bookingId;
    this.amount = amount;
    this.origin = origin;
    this.captchaToken = captchaToken;
  }
}

export interface HeroApiBaseResponse {
  success: boolean;
  message: string;
}

export interface HeroApiWindcaveSessionResponse extends HeroApiBaseResponse {
  sessionRef: string;
}

export interface HeroApiValidateWindcaveSessionResponse extends HeroApiBaseResponse {
  bookingId: string;
}